import { jsx } from "react/jsx-runtime";
import AntTag from "antd/es/tag";
import classnames from "../../utils/classnames.js";
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import './Filter.css';/* empty css            */
const Filter = ({
  children,
  className,
  onClick,
  reset = false,
  closable = true,
  closeIcon = /* @__PURE__ */ jsx(Icon, { name: "cross", sticker: "filter-close-icon", size: 12 }),
  onClose = onClick,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    AntTag,
    {
      onClick,
      onClose,
      closable,
      closeIcon,
      className: classnames(
        [
          "perxis-auto-filter",
          {
            "perxis-auto-filter--reset": reset
          }
        ],
        className
      ),
      ...props,
      children: /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "darkest", className: classnames("perxis-auto-filter__text"), children })
    }
  );
};
export {
  Filter as default
};
//# sourceMappingURL=Filter.js.map
